/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 伝票情報
 * @export
 * @interface UpdateBillingCancellationFee200Response
 */
export interface UpdateBillingCancellationFee200Response {
    /**
     * 伝票ID
     * @type {string}
     * @memberof UpdateBillingCancellationFee200Response
     */
    id: string;
    /**
     * 伝票作成日時
     * @type {Date}
     * @memberof UpdateBillingCancellationFee200Response
     */
    createdAt: Date;
    /**
     * 伝票更新日時
     * @type {Date}
     * @memberof UpdateBillingCancellationFee200Response
     */
    updatedAt: Date;
    /**
     * S.RIDEの注文番号
     * @type {string}
     * @memberof UpdateBillingCancellationFee200Response
     */
    orderNo: string;
    /**
     * ローミング先の注文番号（例：DiDiのOID、UberのTrip UUID）（デフォルト値：空欄）
     * @type {string}
     * @memberof UpdateBillingCancellationFee200Response
     */
    externalOrderNo: string;
    /**
     * 対象サービス（service_category）
     * @type {number}
     * @memberof UpdateBillingCancellationFee200Response
     */
    serviceCategory?: UpdateBillingCancellationFee200ResponseServiceCategoryEnum | null;
    /**
     * 依頼元種別
     * @type {number}
     * @memberof UpdateBillingCancellationFee200Response
     */
    requestSourceType: UpdateBillingCancellationFee200ResponseRequestSourceTypeEnum;
    /**
     * 無線番号
     * @type {string}
     * @memberof UpdateBillingCancellationFee200Response
     */
    radioNo: string;
    /**
     * 車両状態
     * @type {number}
     * @memberof UpdateBillingCancellationFee200Response
     */
    carStatus: UpdateBillingCancellationFee200ResponseCarStatusEnum;
    /**
     * 費目
     * @type {number}
     * @memberof UpdateBillingCancellationFee200Response
     */
    category: UpdateBillingCancellationFee200ResponseCategoryEnum;
    /**
     * 実績支払方法
     * @type {string}
     * @memberof UpdateBillingCancellationFee200Response
     */
    paymentMethod: UpdateBillingCancellationFee200ResponsePaymentMethodEnum | null;
    /**
     * 金額
     * @type {number}
     * @memberof UpdateBillingCancellationFee200Response
     */
    amount: number;
    /**
     * 乗務員名
     * @type {string}
     * @memberof UpdateBillingCancellationFee200Response
     */
    driverName: string;
    /**
     * グループ名
     * @type {string}
     * @memberof UpdateBillingCancellationFee200Response
     */
    groupName: string;
    /**
     * 会社名
     * @type {string}
     * @memberof UpdateBillingCancellationFee200Response
     */
    companyName: string;
    /**
     * 営業所名
     * @type {string}
     * @memberof UpdateBillingCancellationFee200Response
     */
    salesOfficeName: string;
    /**
     * 最新区分
     * @type {boolean}
     * @memberof UpdateBillingCancellationFee200Response
     */
    latest: boolean;
    /**
     * 伝票登録者（メールアドレス）
     * @type {string}
     * @memberof UpdateBillingCancellationFee200Response
     */
    registeredBy: string;
    /**
     * 実行状況（0:実行中, 1:完了）
     * @type {number}
     * @memberof UpdateBillingCancellationFee200Response
     */
    executionStatus: UpdateBillingCancellationFee200ResponseExecutionStatusEnum;
    /**
     * 運賃種別
     * @type {number}
     * @memberof UpdateBillingCancellationFee200Response
     */
    fareType: UpdateBillingCancellationFee200ResponseFareTypeEnum;
    /**
     * 注文種別
     * @type {number}
     * @memberof UpdateBillingCancellationFee200Response
     */
    orderType: UpdateBillingCancellationFee200ResponseOrderTypeEnum;
    /**
     * 実運賃
     * @type {number}
     * @memberof UpdateBillingCancellationFee200Response
     */
    actualFare: number;
    /**
     * 有料道路料金
     * @type {number}
     * @memberof UpdateBillingCancellationFee200Response
     */
    tollroadFee: number;
    /**
     * 立替料金
     * @type {number}
     * @memberof UpdateBillingCancellationFee200Response
     */
    advancedFee: number;
    /**
     * チップ
     * @type {number}
     * @memberof UpdateBillingCancellationFee200Response
     */
    tip?: number;
    /**
     * キャンセル料
     * @type {number}
     * @memberof UpdateBillingCancellationFee200Response
     */
    cancellationFee?: number;
    /**
     * キャンセル料支払方法
     * @type {string}
     * @memberof UpdateBillingCancellationFee200Response
     */
    tipPaymentMethod?: UpdateBillingCancellationFee200ResponseTipPaymentMethodEnum;
    /**
     * キャンセル料支払方法
     * @type {string}
     * @memberof UpdateBillingCancellationFee200Response
     */
    cancellationPaymentMethod?: UpdateBillingCancellationFee200ResponseCancellationPaymentMethodEnum;
}


/**
 * @export
 */
export const UpdateBillingCancellationFee200ResponseServiceCategoryEnum = {
    OVERSEAS_ROAMING: 0
} as const;
export type UpdateBillingCancellationFee200ResponseServiceCategoryEnum = typeof UpdateBillingCancellationFee200ResponseServiceCategoryEnum[keyof typeof UpdateBillingCancellationFee200ResponseServiceCategoryEnum];

/**
 * @export
 */
export const UpdateBillingCancellationFee200ResponseRequestSourceTypeEnum = {
    SRIDE: 0,
    DIDI: 1,
    UBER: 2,
    RINGO_PASS: 3,
    SIMPLE_DISPATCH: 4
} as const;
export type UpdateBillingCancellationFee200ResponseRequestSourceTypeEnum = typeof UpdateBillingCancellationFee200ResponseRequestSourceTypeEnum[keyof typeof UpdateBillingCancellationFee200ResponseRequestSourceTypeEnum];

/**
 * @export
 */
export const UpdateBillingCancellationFee200ResponseCarStatusEnum = {
    REQUESTED: 1,
    SEARCH_FAILED: 2,
    DISPATCHED: 3,
    ARRIVED: 4,
    ON_BOARD: 5,
    SUBSTITUTE_REQUESTED: 6,
    PAYMENT_COMPLETED: 7,
    ONLINE_PAYMENT_FAILED: 8,
    ON_BOARD_QR: 9,
    UNUSED: 10,
    USER_CANCELED: 11,
    OPERATOR_CANCELED: 12,
    QR_CANCELED: 13
} as const;
export type UpdateBillingCancellationFee200ResponseCarStatusEnum = typeof UpdateBillingCancellationFee200ResponseCarStatusEnum[keyof typeof UpdateBillingCancellationFee200ResponseCarStatusEnum];

/**
 * @export
 */
export const UpdateBillingCancellationFee200ResponseCategoryEnum = {
    NORMAL: 0,
    CANCELLATION_FEE: 1,
    TIP: 2
} as const;
export type UpdateBillingCancellationFee200ResponseCategoryEnum = typeof UpdateBillingCancellationFee200ResponseCategoryEnum[keyof typeof UpdateBillingCancellationFee200ResponseCategoryEnum];

/**
 * @export
 */
export const UpdateBillingCancellationFee200ResponsePaymentMethodEnum = {
    IN_CAR_PAYMENT: '0',
    APP_PAYMENT_CREDIT_CARD: '1',
    EITHER: '2',
    APP_PAYMENT_APPLE_PAY: '3',
    RINGO_PASS_PAYMENT: '4',
    BACK_SEAT_PAYMENT: '5',
    APP_PAYMENT_CAB_CARD: '6',
    APP_PAYMENT_S_RIDE_BIZ: '7',
    APP_PAY_PAY: '10',
    APP_AU_PAY: '11',
    APP_D_PAY: '12',
    APP_R_PAY: '13',
    DIDI: '14',
    UBER: '15'
} as const;
export type UpdateBillingCancellationFee200ResponsePaymentMethodEnum = typeof UpdateBillingCancellationFee200ResponsePaymentMethodEnum[keyof typeof UpdateBillingCancellationFee200ResponsePaymentMethodEnum];

/**
 * @export
 */
export const UpdateBillingCancellationFee200ResponseExecutionStatusEnum = {
    NOT_EXECUTED: 0,
    EXECUTED: 1
} as const;
export type UpdateBillingCancellationFee200ResponseExecutionStatusEnum = typeof UpdateBillingCancellationFee200ResponseExecutionStatusEnum[keyof typeof UpdateBillingCancellationFee200ResponseExecutionStatusEnum];

/**
 * @export
 */
export const UpdateBillingCancellationFee200ResponseFareTypeEnum = {
    METER: 0,
    PRE_FIXED: 1,
    FLAT: 2
} as const;
export type UpdateBillingCancellationFee200ResponseFareTypeEnum = typeof UpdateBillingCancellationFee200ResponseFareTypeEnum[keyof typeof UpdateBillingCancellationFee200ResponseFareTypeEnum];

/**
 * @export
 */
export const UpdateBillingCancellationFee200ResponseOrderTypeEnum = {
    NORMAL: 0,
    RESERVATION: 1
} as const;
export type UpdateBillingCancellationFee200ResponseOrderTypeEnum = typeof UpdateBillingCancellationFee200ResponseOrderTypeEnum[keyof typeof UpdateBillingCancellationFee200ResponseOrderTypeEnum];

/**
 * @export
 */
export const UpdateBillingCancellationFee200ResponseTipPaymentMethodEnum = {
    IN_CAR_PAYMENT: '0',
    APP_PAYMENT_CREDIT_CARD: '1',
    EITHER: '2',
    APP_PAYMENT_APPLE_PAY: '3',
    RINGO_PASS_PAYMENT: '4',
    BACK_SEAT_PAYMENT: '5',
    APP_PAYMENT_CAB_CARD: '6',
    APP_PAYMENT_S_RIDE_BIZ: '7',
    APP_PAY_PAY: '10',
    APP_AU_PAY: '11',
    APP_D_PAY: '12',
    APP_R_PAY: '13',
    DIDI: '14',
    UBER: '15'
} as const;
export type UpdateBillingCancellationFee200ResponseTipPaymentMethodEnum = typeof UpdateBillingCancellationFee200ResponseTipPaymentMethodEnum[keyof typeof UpdateBillingCancellationFee200ResponseTipPaymentMethodEnum];

/**
 * @export
 */
export const UpdateBillingCancellationFee200ResponseCancellationPaymentMethodEnum = {
    IN_CAR_PAYMENT: '0',
    APP_PAYMENT_CREDIT_CARD: '1',
    EITHER: '2',
    APP_PAYMENT_APPLE_PAY: '3',
    RINGO_PASS_PAYMENT: '4',
    BACK_SEAT_PAYMENT: '5',
    APP_PAYMENT_CAB_CARD: '6',
    APP_PAYMENT_S_RIDE_BIZ: '7',
    APP_PAY_PAY: '10',
    APP_AU_PAY: '11',
    APP_D_PAY: '12',
    APP_R_PAY: '13',
    DIDI: '14',
    UBER: '15'
} as const;
export type UpdateBillingCancellationFee200ResponseCancellationPaymentMethodEnum = typeof UpdateBillingCancellationFee200ResponseCancellationPaymentMethodEnum[keyof typeof UpdateBillingCancellationFee200ResponseCancellationPaymentMethodEnum];


/**
 * Check if a given object implements the UpdateBillingCancellationFee200Response interface.
 */
export function instanceOfUpdateBillingCancellationFee200Response(value: object): value is UpdateBillingCancellationFee200Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('orderNo' in value) || value['orderNo'] === undefined) return false;
    if (!('externalOrderNo' in value) || value['externalOrderNo'] === undefined) return false;
    if (!('requestSourceType' in value) || value['requestSourceType'] === undefined) return false;
    if (!('radioNo' in value) || value['radioNo'] === undefined) return false;
    if (!('carStatus' in value) || value['carStatus'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('driverName' in value) || value['driverName'] === undefined) return false;
    if (!('groupName' in value) || value['groupName'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('salesOfficeName' in value) || value['salesOfficeName'] === undefined) return false;
    if (!('latest' in value) || value['latest'] === undefined) return false;
    if (!('registeredBy' in value) || value['registeredBy'] === undefined) return false;
    if (!('executionStatus' in value) || value['executionStatus'] === undefined) return false;
    if (!('fareType' in value) || value['fareType'] === undefined) return false;
    if (!('orderType' in value) || value['orderType'] === undefined) return false;
    if (!('actualFare' in value) || value['actualFare'] === undefined) return false;
    if (!('tollroadFee' in value) || value['tollroadFee'] === undefined) return false;
    if (!('advancedFee' in value) || value['advancedFee'] === undefined) return false;
    return true;
}

export function UpdateBillingCancellationFee200ResponseFromJSON(json: any): UpdateBillingCancellationFee200Response {
    return UpdateBillingCancellationFee200ResponseFromJSONTyped(json, false);
}

export function UpdateBillingCancellationFee200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBillingCancellationFee200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'orderNo': json['order_no'],
        'externalOrderNo': json['external_order_no'],
        'serviceCategory': json['service_category'] == null ? undefined : json['service_category'],
        'requestSourceType': json['request_source_type'],
        'radioNo': json['radio_no'],
        'carStatus': json['car_status'],
        'category': json['category'],
        'paymentMethod': json['payment_method'],
        'amount': json['amount'],
        'driverName': json['driver_name'],
        'groupName': json['group_name'],
        'companyName': json['company_name'],
        'salesOfficeName': json['sales_office_name'],
        'latest': json['latest'],
        'registeredBy': json['registered_by'],
        'executionStatus': json['execution_status'],
        'fareType': json['fare_type'],
        'orderType': json['order_type'],
        'actualFare': json['actual_fare'],
        'tollroadFee': json['tollroad_fee'],
        'advancedFee': json['advanced_fee'],
        'tip': json['tip'] == null ? undefined : json['tip'],
        'cancellationFee': json['cancellation_fee'] == null ? undefined : json['cancellation_fee'],
        'tipPaymentMethod': json['tip_payment_method'] == null ? undefined : json['tip_payment_method'],
        'cancellationPaymentMethod': json['cancellation_payment_method'] == null ? undefined : json['cancellation_payment_method'],
    };
}

export function UpdateBillingCancellationFee200ResponseToJSON(json: any): UpdateBillingCancellationFee200Response {
    return UpdateBillingCancellationFee200ResponseToJSONTyped(json, false);
}

export function UpdateBillingCancellationFee200ResponseToJSONTyped(value?: UpdateBillingCancellationFee200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'created_at': ((value['createdAt']).toISOString()),
        'updated_at': ((value['updatedAt']).toISOString()),
        'order_no': value['orderNo'],
        'external_order_no': value['externalOrderNo'],
        'service_category': value['serviceCategory'],
        'request_source_type': value['requestSourceType'],
        'radio_no': value['radioNo'],
        'car_status': value['carStatus'],
        'category': value['category'],
        'payment_method': value['paymentMethod'],
        'amount': value['amount'],
        'driver_name': value['driverName'],
        'group_name': value['groupName'],
        'company_name': value['companyName'],
        'sales_office_name': value['salesOfficeName'],
        'latest': value['latest'],
        'registered_by': value['registeredBy'],
        'execution_status': value['executionStatus'],
        'fare_type': value['fareType'],
        'order_type': value['orderType'],
        'actual_fare': value['actualFare'],
        'tollroad_fee': value['tollroadFee'],
        'advanced_fee': value['advancedFee'],
        'tip': value['tip'],
        'cancellation_fee': value['cancellationFee'],
        'tip_payment_method': value['tipPaymentMethod'],
        'cancellation_payment_method': value['cancellationPaymentMethod'],
    };
}

